import type { FC } from 'react'
import clsx from 'clsx'

import FileQuestion03 from '@sylveraio/untitled-ui-icons-react/build/esm/FileQuestion03'

import { SylveraScoreSizes } from '../../types'
import { Ring } from '../SylveraRating/SylveraRating'

import type { DataMissingProps } from './types'

const ICON_SIZE_MAP = {
  xs: 'w-3',
  sm: 'w-5',
  xl: 'w-7',
  '3xl': 'w-12',
} satisfies Partial<Record<SylveraScoreSizes, `w-${number}`>>

export const DataMissing: FC<DataMissingProps> = ({
  size,
  testId = 'data-missing',
}) => {
  return (
    <Ring testId={testId} size={size} className="shrink-0" ringType="outer">
      <div className="absolute inset-0 h-full w-full rounded-full shadow-rating" />
      <Ring size={size} hasRating ringType="middle" className="h-full w-full">
        <div className="flex h-full w-full items-center justify-center rounded-full bg-high">
          <FileQuestion03
            className={clsx('text-content-action-default', ICON_SIZE_MAP[size])}
          />
        </div>
      </Ring>
    </Ring>
  )
}
